/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

export const kAK = 'sKOR1iZ8dB2Ry3o7NjIQaBa0LGA40vY5';

export const kOptsLg = {
  title: '',
  width: 300,
  enableMessage: true,
};

export const kOptsSm = {
  title: '',
  width: 100,
  enableMessage: true,
};

export const kDlKeys = ['nodeid', 'name', 'metrics.snr', 'metrics.rssi', 'metrics.lng', 'metrics.lat', 'timestamp'];

export const kheader = {
  en: {
    nodeid: 'DEVEUI',
    'metrics.snr': 'SNR',
    'metrics.rssi': 'RSSI',
    'metrics.lng': 'Longitude',
    'metrics.lat': 'Latitude',
    timestamp: 'Time',
    name: 'Name',
  },
  zh: {
    nodeid: 'DEVEUI',
    'metrics.snr': 'SNR',
    'metrics.rssi': 'RSSI',
    'metrics.lng': '经度',
    'metrics.lat': '纬度',
    timestamp: '时间',
    name: '名称',
  },
};

export const kTimeFormat = {
  zh: 'YYYY-MM-DD HH:mm:ss',
  en: 'MM/DD/YYYY HH:mm:ss',
};

export default {
  kAK,
  kOptsLg,
  kOptsSm,
  kDlKeys,
  kheader,
  kTimeFormat,
};




// WEBPACK FOOTER //
// ./src/containers/Network/coms/RoadTestView/coms/GpsMap/consts.js